<template>
  <div id="shoppingShareId">
    <div class="">
      <el-form class="productShortNameForm" :inline="true" :model="form" ref="ruleForm" label-width="70px">
        <el-form-item label="店铺名称" prop="mallCode">
          <el-input maxlength="50" v-model="form.queryMallName" placeholder="请输入店铺名称"></el-input>
        </el-form-item>
        <el-form-item class="btn-r" label="" >
          <el-button type="primary" @click="searchProductList" icon="el-icon-search">查询</el-button>
          <el-button class="normal-btn" @click="resetForm"><i class="el-icon-refresh-left y-fc-4C84FF"></i>重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="yto-table ">
      <el-alert class="alert" title type="info" :closable="false" show-icon>
        <span>1、可以将店铺分享出去，他人可直接接收分享，不用再重复店铺授权的操作。</span>
        <br/>
        <span>2、接收分享后，他人可以查看编辑店铺数据，请谨慎操作！</span>
      </el-alert>
      <div class="btn-group" style="text-align:left;padding: 0px 0px 20px 0px;display:flex;">
        <div style="margin-left: 10px">
          <el-button type="primary" @click="createShareIdFn">创建分享店铺码</el-button>
        </div>
        <div style="margin-left: 10px">
          <el-button style="height: 34px;" plain @click="lookShareJc" >查看教程</el-button>
        </div>
      </div>
      <el-table :data="tableData" tooltip-effect="light" v-loading="loading" border :span-method="objectSpanMethod">
        <el-table-column
          label="店铺名称">
          <template slot-scope="scope">
            <img :src="require(`@/assets/images/ecommercepng/icon_dianpu_${scope.row.platformCode}.png`)" class="iconstyle" alt="">
            <span >{{ scope.row.mallName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="modifyTime"
          label="分享店铺码更新时间">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="分享店铺码">
          <template slot-scope="scope">
            <span >{{ scope.row.joinCode }}</span>
            <i class="el-icon-document-copy" title="复制" @click.prevent.stop="copyShareIdInfo(scope.row)"></i>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="updateShareId(scope.row)">更新分享店铺码</el-button>
            <el-button type="text" class="y-fc-F35252" size="small" @click="deleteShareId(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="limitChange"
        @current-change="pageChange"
        :current-page.sync="page.pageNo"
        :page-sizes="[10, 50, 100]"
        :page-size="page.limit"
        layout="total, sizes, prev, pager, next"
        :total="page.total">
      </el-pagination>
    </div>
    <!-- 批量导入弹窗 -->
    <el-dialog title="创建分享店铺码" :visible.sync="importXlsDialog" width="710px" center :before-close="closeShare" :close-on-click-modal="false">
      <div class="create-share-shoppingId">
        <el-alert class="alert" title type="info" :closable="false" show-icon>
          <span>1、仅显示当前用户账户下授权正常的店铺。</span>
          <br/>
          <span>2、通过他人分享的店铺，不支持再次分享。</span>
        </el-alert>
        <div class="create-title">请添加店铺：</div>
        <div class="checkbox-content">
          <el-checkbox-group v-model="checkList">
            <el-checkbox class="checkbox-width" v-for="item in shoppingList" :key="item.id" :label="item">
              <img :src="require(`@/assets/images/ecommercepng/icon_dianpu_${item.paltformCode}.png`)" class="iconstyle" alt="">
              <el-tooltip class="item" effect="dark" :content="item.mallName" placement="top">
            <span class="check-title">{{item.mallName}}</span>
            </el-tooltip>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="check-total"><span>已选{{checkList.length}}个店铺</span><div class="check-right-margin" @click="(e)=>selectFn(e)"><span data-type="all" class="selected-style">全选</span>|<span data-type="allNo" class="selected-style">反选</span>|<span data-type="No" class="selected-style">清空</span></div></div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeShare" plain>取 消</el-button>
        <el-button type="primary" @click="shareShopCreateShopConfigFn" >确 定</el-button>
      </div>
    </el-dialog>
    <!--提示弹框-->
    <el-dialog title="提示" :visible.sync="tipFlag" width="710px" center :before-close="closeTip" :close-on-click-modal="false">
      <div class="create-share-shoppingId-tip">
        <div class="tip-content">
          创建成功，请将下方分享店铺码复制分享给他人，在【客户管家电脑端->基础信息->电商平台店铺页面->点击接收他人店铺】即可关联。
        </div>
        <div class="tip-share-title">分享店铺码：</div>
        <div class="tip-share-code">{{joinData}}<i class="el-icon-document-copy" title="复制" @click.prevent.stop="copyShareIdInfo({'joinCode':joinData})"></i></div>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- shareFlag true时 显示 复制弹框 updata true 更新分享码弹框-->
        <el-button  type="primary" @click="closeTip" >确 定</el-button>
      </div>
    </el-dialog>
    <!--删除更新提示提示弹框-->
    <el-dialog title="提示" :visible.sync="deleteFlag" width="710px" center :before-close="closeDel" :close-on-click-modal="false">
      <div class="create-share-shoppingId-tip">
        <div class="tip-content-delete" v-if="!deleteOrUpdateFlag&&!noMobileFlag">
          更新后，原来的分享店铺码将失效，但是通过原来分享码获得授权的店铺不受影响。
        </div>
        <div class="tip-content-delete" v-if="deleteOrUpdateFlag&&!noMobileFlag">
          删除后，分享店铺码将失效，原来通过该店铺码分享授权的电商店铺均将授权失效！
        </div>
        <div class="tip-content-delete" v-if="noMobileFlag">
          为了保障您的店铺数据安全，需要您通过手机号登录的方式登录客户管家用于店铺分享。
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- shareFlag true时 显示 复制弹框 updata true 更新分享码弹框-->
        <el-button  plain v-if="!noMobileFlag" @click="closeDel">取 消</el-button>
        <el-button v-if="deleteOrUpdateFlag&&!noMobileFlag" type="primary" @click="DeleteFn" >确 定</el-button>
        <el-button v-if="!deleteOrUpdateFlag&&!noMobileFlag" type="primary" @click="UpdateFn" >确 定</el-button>
        <el-button v-if="noMobileFlag" type="primary" @click="noMobileFn" >确 定</el-button>
        <el-button  plain v-if="noMobileFlag" @click="noMobileFnJc">查看教程</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { copyText,getSpanArr,objectSpanMethod } from '@/utils/util.js';
import { shareShopQueryShopConfig,shareShopCreateShopConfig,shareShopUpdateShopConfig,shareShopDeleteShopConfig } from '../../../api/baseInfo/shopManage/shoppingShareId';
import { getStoreListApi } from '../../../api/baseInfo/shopManage/storeManagement';
export default {
  name: 'customerCode',
  data() {
    return {
      noMobileFlag:false,
      updateDate:{},
      spanArr:[],
      indexColumArr:[2,3],
      deleteDate:{},
      deleteOrUpdateFlag:false,//false是 update true是delete
      joinData:'',
      deleteFlag:false,
      tipFlag:false,
      checkList:[],
      shoppingList:[],
      form: {
        paltformCode: '',
        mallCode: '', // 店铺code
        id: '', // 店铺id
      },
      data: {},
      limit: 1,
      page: {
        pageNo: 1,
        limit: 10,
        total: 0
      },
      tableData: [],
      importXlsDialog: false, // 批量导入的弹窗
      loading: false,
    };
  },
  methods: {
    selectFn(e){
      try{
        let type = e.target.dataset.type;
        if(type == "all"){
          this.checkList = this.shoppingList;
        }else if(type == "allNo"){
          let temp = new Set(this.checkList);
          this.checkList = [...new Set(this.shoppingList.filter(x=>!temp.has(x)))];
        }else if(type=="No"){
          this.checkList = [];
        }
      }catch(err){
        console.log("e",err);
      }
    },
    lookShareJc(){
      window.open('https://kh.yto.net.cn/new/helpCenter?typeId=33&problemId=268');
    },
    noMobileFn(){
      this.deleteFlag = false;
    },
    noMobileFnJc(){
      this.deleteFlag = false;
      window.open('https://kh.yto.net.cn/new/helpCenter?typeId=35&problemId=267');
      //查看教程
    },
    objectSpanMethod:objectSpanMethod,
    DeleteFn(){
      let {joinCodeId,id} = this.deleteDate;
      shareShopDeleteShopConfig({joinCodeId,id}).then(res=>{
        if(res.success){
          this.$message({
            message: res.message||"删除成功",
            type: 'success'
          });
          this.searchProductList();
          this.deleteFlag = false;
        }else{
          this.$message.error(res.message);
        }
      },err=>{
        this.$message.error(err);
      }).catch(e=>{
        this.$message.error(e);
      })
    },
    //删除店铺
    deleteShareId(row){
      console.log('deleteShareId',row);
      this.deleteDate = row;
      this.deleteOrUpdateFlag = true;
      this.deleteFlag = true;
    },
    //更新店铺
    UpdateFn(){
      let {joinCodeId} = this.updateDate;
      let mallList = this.tableData.filter(item=>item.joinCodeId==joinCodeId);
      mallList = mallList.map(item=>{
        let {id,platformMallCode} = item;
        return {
          id,platformMallCode
        }
      });
      shareShopUpdateShopConfig({
        mallList,
        joinCodeId,
      }).then(res=>{
        if(res.success){
          this.$message({
            message: res.message,
            type: 'success'
          });
          this.searchProductList();
          this.deleteFlag = false;
        }else{
          this.$message.error(res.message);
        }
      },err=>{
         this.$message.error(err);
      }).catch(e=>{
        this.$message.error(e);
      })
    },
    updateShareId(row){
       console.log('updateShareId',row);
      this.updateDate = row;
      this.deleteOrUpdateFlag = false;
      this.deleteFlag = true;
    },
    shareShopCreateShopConfigFn(){
      if(this.checkList.length){
        let mallList = this.checkList.map(item=>{
          let {mallCode,mallName,paltformCode:platformCode} = item;
          return {
            mallCode,mallName,platformCode
          }
        });
        this.checkList = [];
        shareShopCreateShopConfig({mallList}).then(res=>{
          if(res.success){
            this.joinData = res.data;
            this.importXlsDialog = false;
            this.tipFlag = true;
            
          }else{
            this.importXlsDialog = false;
            this.$message.error(res.message);
          }
        },err=>{
          this.$message.error(err);
        }).catch(e=>{
          this.$message.error(e);
        })
      }else{
        this.$message({
          message: '请选择店铺',
          type: 'warning'
        })
        //没有选择店铺 弹框
      }

    },
    getStoreList(){
      let params = {"pageNo":1,"limit":10000, "userId": this.userMess.loginId,isDelete:0,expiredStatus:0,defineExpiredStatus:"Y",platFlag:"1"};
      getStoreListApi(params).then(res=>{
        if (res.message === 'ok') {
          if(res.data&&res.data.items){
            let shoppingList = res.data.items.filter(item=>!item.shareId);this.shoppingList = shoppingList || [];
          }else{
            this.shoppingList  = [];
          }
         
          
        } else {
          this.shoppingList = [];
        }
        return true;
      }).catch(err=>{
        return true;
      })
    },
    closeDel(){
      this.deleteFlag = false;
      this.deleteOrUpdateFlag = false;
      this.noMobileFlag = false;
    },
    closeTip(){
      this.tipFlag = false;
      this.searchProductList();
    },
    closeShare(){
      this.checkList = [];
      this.importXlsDialog = false;
    },
    // 复制收件人信息
    copyShareIdInfo(row) {
      let shareIdInfo = row.joinCode;
      copyText(shareIdInfo);
    },
    createShareIdFn(){
      console.log('this.userMess',this.userMess);
      if(this.userMess.mobile){
        Promise.resolve(this.getStoreList()).then(res=>{
          console.log('this.shoppingList',this.shoppingList);
          this.importXlsDialog = true
        },err=>{
          //未获取到店铺信息提示下哈

        })
      }else{
        this.deleteFlag = true;
        this.noMobileFlag = true;
      }

    },
    limitChange(limt) {
      this.page.pageNo = 1;
      this.page.limit = limt;
      this.shareShopQueryShopConfigFn();
    },
    pageChange(pageNo) {
      this.page.pageNo = pageNo;
      this.shareShopQueryShopConfigFn();
    },
    // 重置查询条件
    resetForm() {
      this.form.queryMallName = '';
      this.checkList = [];
      this.pageChange(1);
    },
    // 查询商品简称列表
    shareShopQueryShopConfigFn() {
      this.loading = true;
        let params = {
          queryMallName: this.form.queryMallName||'',
          pageNum:this.page.pageNo,
          pageSize:this.page.limit
        }
        shareShopQueryShopConfig(params).then(res => {
          if(res.success) {
            if(res.data) {
              let resData = res.data.list || [];
              this.tableData = resData;
              this.spanArr = getSpanArr(this.tableData,'joinCodeId');
              this.page.total = res.data.total;
            } else {
              this.$message.error('获取数据失败');
              this.tableData = [];
              this.page.total = 0;
            }
          } else {
            this.tableData = [];
            this.$message.error(res.message);
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
          this.tableData = [];
        });
    },
    // 查询
    searchProductList() {
      this.page.pageNo = 1;
      this.shareShopQueryShopConfigFn();
    },
  },
  mounted(){
    this.searchProductList();
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables";
.iconstyle {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-right: 3px;
}
/deep/ .el-alert--info  {
  width: 600px;
}
/deep/ .el-icon-info{
  margin-top: -11px;
}
.btn-group{
  margin-top: 10px;
  margin-left: -9px;
}
.btn-r {
  position: absolute;
  right: 10px;
  width: auto !important;
}
#shoppingShareId{
.el-icon-document-copy {
  margin-left: 5px;
  font-size: 10px;
  color: $blue-style;
  cursor: pointer;
}
.create-share-shoppingId-tip{
   color: #333333;
   font-weight: 400;
  .tip-content{
      padding-left: 93px;
      padding-bottom: 12px;
      line-height: 20px;
  }
  .tip-share-title,.tip-share-code{
    padding-left: 93px;
  }
  .tip-share-code{
    color: $blue-style;
    padding-top:8px;
  }
}
.create-share-shoppingId{
  width:600px;
  .create-title{
    width: 84px;
    height: 22px;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    margin:12px 0;
  }
  /deep/ .el-icon-info{
    margin-top: -14px;
  }
  .checkbox-width{
    width:170px;
    margin-top: 10px;
   
  }
  .check-title{
    font-size:14px;

    width:150px;
    overflow: hidden;//溢出隐藏
    white-space: nowrap;//禁止换行
    text-overflow: ellipsis;//...
    display:inline-block;
    vertical-align: middle;
    font-weight: 400;
    color: #333333;
  }
}
.checkbox-content{
    border-bottom: 1px solid #D9D9D9;
    padding-bottom: 22px;
}
.check-total{
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  margin-top: 4px;
  display: flex;
  justify-content: space-between;
}
}
.selected-style{
  cursor: pointer;
  color: $blue-style;
  padding: 0 5px;
}
.check-right-margin{
  margin-right: 54px;
}


</style>
